import { Form } from 'antd';
import useHasChanges from "./useHasChanges";
import useRequiredFieldsFilled from "./useRequiredFieldsFilled";


export default function ButtonSectionController({
  initialValues,
  children,
  closeModal,
}) {
  const values = {
    password: Form.useWatch(['password']),
    email: Form.useWatch(['email']),
  };
  const hasChanges = useHasChanges({ initialValues, values });
  const requiredFieldsFilled = useRequiredFieldsFilled(values);
  return children({
    props: {
      save: {
        disabled: !hasChanges || !requiredFieldsFilled,
      },
      popConfirm: {
        onConfirm: closeModal,
      },
      close: {
        onClick: closeModal,
      },
    },
    hasChanges,
  });
}